import { convertControl } from '@/emap-utils';
export default class EmapPlugin {
  install(ctx) {
    // 转换 Emap 列定义格式
    ctx.plugin('format-schema', (vm, model) => {
      if (!model) {
        return null;
      }

      try {
        if (model) {
          const result = { ...model,
            children: convertControl(model.children).map(item => {
              if (item.options['search.JSONParam']) {
                try {
                  const params = JSON.parse(item.options['search.JSONParam']);

                  if (params.optionData && Array.isArray(params.optionData)) {
                    item.options.options = params.optionData;
                  }
                } catch (e) {
                  console.error(e);
                }
              }

              return item;
            })
          };
          return result;
        }
      } catch (e) {
        console.error('emap 格式解析失败', e.message);
      }

      return null;
    });
  }

}